/**
 * Shape every `auftragId` has on the wire (UUIDv7, api-contracts §8) — checked before the value
 * is ever used in a request so a missing/malformed query parameter never reaches the API
 * (Security, react-typescript §8.4).
 */
const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** `true` only for a syntactically well-formed UUID. */
export function isValidAuftragId(value: string | null): value is string {
  return value !== null && UUID_PATTERN.test(value);
}
